import styled from "styled-components";

export const ToolsPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  height: 60px;

  > div:first-child {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    > * {
      margin: 0;
      display: block;
    }

    > *:nth-child(2) {
      color: ${(props) => props.davysGrey};
    }
  }
`;

export const ToolsPageContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CircularProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
`;
